import { http } from '@/core/api/';
const apiUrl = 'api/public-portal-application';

export const getList = () => {
  return http.get(`${apiUrl}/list`);
};

export const toggle = (id) => {
  return http.post(`${apiUrl}/toggle/${id}`);
};

export const save = (payload) => {
  return http.post(`${apiUrl}`, payload);
};

export const getEditionData = (id) =>  {
  return http.get(`${apiUrl}/edition/${id}`);
};
